import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

function initSentry(): void {
  if (environment.sendToSentry && environment.version !== '') {
    Sentry.setTag('environment', environment.env);
    Sentry.init({
      dsn: 'https://2ee03aa9af0f4036ba795e3e4e42ddc7@sentry.nb.no/4',
      release: environment.version,
    });
  }
}

initSentry();

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(() => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('./safety-worker.js');
      }
    })
    .catch((err) => console.log(err));
});
